// https://wiki.one.int.sap/wiki/display/CONPDI/Preferred+Name+Locale+Rubric
export var formatEmployeeName = function (formatters, _a) {
    var firstName = _a.firstName, lastName = _a.lastName, preferredName = _a.preferredName, fullName = _a.fullName;
    // backwards compatibility
    if (!firstName && !lastName && !preferredName) {
        return fullName;
    }
    var locale = formatters.preferences.locale;
    var lowerCaseLang = locale.toLowerCase();
    if (preferredName) {
        if (['cs', 'fr', 'de', 'id', 'it', 'pl', 'ro', 'th', 'tr', 'ms', 'sl', 'el', 'vi'].includes(lowerCaseLang)) {
            return "".concat(firstName, " ").concat(lastName);
        }
        if (['hu'].includes(lowerCaseLang)) {
            return "".concat(lastName, " ").concat(firstName);
        }
        if (['ko', 'ja'].includes(lowerCaseLang)) {
            return "".concat(lastName, " ").concat(preferredName);
        }
        if (['zh-cn', 'zh-tw'].includes(lowerCaseLang)) {
            return "".concat(lastName).concat(preferredName);
        }
        return "".concat(preferredName, " ").concat(lastName);
    }
    if (['hu', 'ko', 'ja'].includes(lowerCaseLang)) {
        return "".concat(lastName, " ").concat(firstName);
    }
    if (['zh-cn', 'zh-tw'].includes(lowerCaseLang)) {
        return "".concat(lastName).concat(firstName);
    }
    return "".concat(firstName, " ").concat(lastName);
};
